import moment from "moment";

import { useMemo } from "react";

import { db } from "astrid-firebase";
import productionStatuses from "astrid-firestore/src/api/productions/constants/productionStatuses";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import { useProfile } from "../../../../authentication/state/profile";

export default function useUpcomingDeliveries({ organization }) {
	const user = useProfile();

	const [productions, loading, error] = useCollectionData(
		useMemo(
			() =>
				db
					.collection("productions")
					.where("publisher", "==", organization.id)
					.where("publisherManagerIds", "array-contains", user.id)
					.where("deleted", "==", false)
					.where("deliveryDate", "<", moment().add(14, "days").toDate())
					.where("status", "in", [
						productionStatuses.PLANNING,
						productionStatuses.ACCEPTED,
						productionStatuses.PRODUCTION,
					]),
			[organization.id, user.id],
		),
	);

	return [productions, loading, error];
}
